module.exports = "<p>\r\n  preloader works!\r\n</p>\r\n"